import React, { FC, useState, useEffect, createRef, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
    PageHeader, Space, Table, Popover, Form, Spin, Row, Col, Empty, ConfigProvider, Tabs, Card, Typography
} from 'antd'
import type { FormInstance } from 'antd/es/form/Form'
import { StarFilled, StarOutlined } from '@ant-design/icons'
import zhCN from 'antd/es/locale/zh_CN'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import type { IAppState } from '@/store/reducers'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import { getOnlineReviewById, getOnlineReviewResult, getOnlineReviewTMT, relevantGetById } from '@/services/progress.service'
// import { wrapText } from '@/pages/table2'
import Nav from '@/components/nav'

// type EditableTableProps = Parameters<typeof Table>[0]
// type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>

const OnlineReviewTMTLs: FC = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const route = useSelector((state: IAppState) => state.router)
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    // const paginationInfo = useSelector((state: IAppState) => state.tableEditData.keyRoadMapPagination)
    // const [tableData, setTableData] = useState<any[]>([])
    // 反馈结果报告
    const [formData, setFormData] = useState<any>(undefined)
    // 提案信息
    const [formObj, setFormObj] = useState<any>(undefined)
    const [loaded, setLoaded] = useState<any>(false)
    const [progressName, setProgressName] = useState('')
    const [feedbackList, setFeedbackList] = useState<any>(null)
    const [feedbackTMTList, setFeedbackTMTList] = useState<any>(null)
    const formRef = createRef<FormInstance>()
    const { TabPane } = Tabs
    const { Text } = Typography

    const layout = {
        labelCol: { span: 10 },
        wrapperCol: { span: 14 },
    }

    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    // const defaultColumns: (ColumnTypes[number] & { dataIndex: string })[] = [
    //     {
    //         title: t('isParticipate'),
    //         dataIndex: 'isParticipate',
    //         key: 'isParticipate',
    //         width: 160,
    //     },
    //     {
    //         title: t('isPassed'),
    //         dataIndex: 'isPassed',
    //         key: 'isPassed',
    //         width: 160,
    //     },
    //     {
    //         title: t('reviewContent'),
    //         dataIndex: 'reviewContent',
    //         key: 'reviewContent',
    //         width: 160,
    //         render (value) {
    //             if (value && (value.includes('<div') || value.includes('<span'))) {
    //                 return <Popover 
    //                     title=""
    //                     content={
    //                         <div dangerouslySetInnerHTML={{
    //                             __html: (value.includes('"str":') && value.includes('"obj":')) ? JSON.parse(value).str : value
    //                         }}></div>
    //                     }
    //                 >
    //                     <div style={{ maxWidth: 140 }}
    //                         className='table_ellipsis' dangerouslySetInnerHTML={{
    //                             __html: (value.includes('"str":') && value.includes('"obj":')) ? JSON.parse(value).str : value
    //                         }}
    //                     ></div>
    //                 </Popover>
    //             } else {
    //                 return wrapText(value)
    //             }
    //         }
    //     },
    // ]

    const joinTranslatedStrings = (...translations: string[]): string => {
        return translations.join(i18n.language !== 'zh' ? ' ' : '')
    }
    const approvalType = [
        { id: 1, label: joinTranslatedStrings(t('technicalPlan'), t('approval')) },
        { id: 2, label: joinTranslatedStrings(t('technicalDefineAndResearchTaskBook'), t('approval')) },
        { id: 3, label: joinTranslatedStrings(t('technicalAchievementDelivery'), t('approval')) },
        { id: 4, label: joinTranslatedStrings(t('buTMTApproveTech'), t('approval')) },
    ]
    const technologicalLeadershipArr = useRef([{
        label: t('leadership'),
        id: 1
    }, 
    {
        label: t('homeleadership'),
        id: 4
    },
    {
        label: t('equalize'),
        id: 2
    }, {
        label: t('trail'),
        id: 3
    }])
    const technicalContributionArr = useRef([{
        label: t('innovationSellingPoint'),
        id: 1
    }, {
        label: t('keySellingPoint'),
        id: 2
    }, {
        label: t('secondarySellingPoints'),
        id: 3
    }, {
        label: t('basicTechnology'),
        id: 4
    }])
    const findLabel = (arr: any[], id: number) =>
        arr.find(((item: any) => item.id === id))?.label ?? ''

    const columns = [
        {
            title: () => <span>{t('feedbackName')}</span>,
            dataIndex: 'creatorName',
            key: 'creatorName',
            width: 202,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('WorkGroup')}</span>,
            dataIndex: 'workGroup',
            key: 'workGroup',
            width: 200,
            ellipsis: { showTitle: true },
            render(value: any) {
                return value?.workGroupName || ''
            }
        },
        {
            title: () => <span>{t('isRelevant')}</span>,
            dataIndex: 'isRelevant',
            key: 'isRelevant',
            width: 120,
            ellipsis: { showTitle: true },
            // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
            render(value: boolean, record: any) {
                if (record.auditOrNot) {
                    return <span>{t('sitInOn')}</span>
                } else {
                    if (value !== null) {
                        if (value) {
                            return <span>{t('Yes')}</span>
                        }
                        return <span>{t('No')}</span>
                    } else {
                        return <></>
                    }
                }
            }
        },
        {
            title: () => <span>{t('tmtUser')}</span>,
            dataIndex: 'tmtInfos',
            key: 'tmtInfos',
            width: 250,
            ellipsis: { showTitle: true },
            render(value: any[]) {
                return value.map(item => item.tmtFullUser).join(',')
            }
        },
        {
            title: () => <span>{t('description')}</span>,
            dataIndex: 'description',
            key: 'description',
            // width: 150,
            ellipsis: { showTitle: true },
            render(value: string) {
                return <Popover
                    placement="topLeft"
                    title=""
                    content={
                        <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', wordBreak: 'break-all' }}
                            dangerouslySetInnerHTML={{
                                __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                            }}
                        ></div>
                    }
                >
                    <div style={{ maxWidth: 240 }}
                        className='table_ellipsis'
                        dangerouslySetInnerHTML={{
                            __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                        }}
                    ></div>
                </Popover>
            }
        },
    ]
    const tmtColumns = [
        {
            title: () => <span>{t('feedbackName')}</span>,
            dataIndex: 'tmtFullUser',
            key: 'tmtFullUser',
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('WorkGroup')}</span>,
            dataIndex: 'workGroup',
            key: 'workGroup',
            width: 150,
            ellipsis: { showTitle: true },
            render(value: any) {
                return value?.workGroupName || ''
            }
        },
        {
            title: () => <span>{t('feedbackName') + (i18n.language !== 'zh' ? ' ' : '') + t('type')}</span>,
            dataIndex: 'isPL',
            key: 'isPL',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: number) {
                // 增加除了PL TMT之外的都是TMT
                return ((value === 1 || value === 2) ? <span>PL TMT</span> : <span>TMT</span>)
            }
        },
        {
            title: () => <span>{t('technologicalLeadership')}</span>,
            dataIndex: 'technologyLeadership',
            key: 'technologyLeadership',
            width: 150,
            ellipsis: { showTitle: true },
            render(value: number, record: any) {
                if (!value && formObj) {
                    if (record.tmtFullUser === formObj.creator) {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        return findLabel(technologicalLeadershipArr.current, formObj.technologyLeadership)
                    }
                }
                return findLabel(technologicalLeadershipArr.current, value)
            }
        },
        {
            title: () => <span>{t('technicalContribution')}</span>,
            dataIndex: 'technologyContribution',
            key: 'technologyContribution',
            width: 120,
            ellipsis: { showTitle: true },
            render(value: number, record: any) {
                if (!value && formObj) {
                    if (record.tmtFullUser === formObj.creator) {
                        console.log('formObj: ', formObj)
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        return findLabel(technicalContributionArr.current, formObj.technologyContribution)
                    }
                }
                return findLabel(technicalContributionArr.current, value)
            }
        },
        {
            title: () => <span>{t('techType')}</span>,
            dataIndex: 'coreTechnology',
            key: 'coreTechnology',
            width: 120,
            ellipsis: { showTitle: true },
            render(value: number, record: any) {
                const labelArr = [t('core') + (i18n.language !== 'zh' ? ' ' : '') + t('technology'),
                    t('key') + (i18n.language !== 'zh' ? ' ' : '') + t('technology'),
                    t('basicTechnology'),
                    t('reserveTechnology'),
                ]
                if (!value && formObj) {
                    if (record.tmtFullUser === formObj.creator) {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        return labelArr[formObj.coreTechnology]
                    }
                }
                return labelArr[value]
            }
        },
        {
            title: () => <span>{t('reviewResultTrue')}</span>,
            dataIndex: 'isPassed',
            key: 'isPassed',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: boolean | null, record: any) {
                if (value !== null) {
                    return value ? <span>{t('Yes')}</span> : <span>{t('No')}</span>
                } else if (value === null && record.reviewContent?.length > 0 && record.judgesType !== 2) {
                    return <span>{t('waiver')}</span>
                } else {
                    return <></>
                }
            }
        },
        {
            title: () => <span>{t('wcYOCuH76At1ckcMdzKKf')}</span>,
            dataIndex: 'judgesType',
            key: 'judgesType',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: number | null) {
                if(value === 1 ){
                    return <span>{t('T33AqK8KbZMESLZl4j41q')}</span>
                }else if(value === 2){
                    return <span>{t('XyU0VPlblKWVpW6SokzAQ')}</span>
                }else{
                    return <></>
                }
                
            }
        },
        {
            title: () => <span>{t('tmtMail')}</span>,
            dataIndex: 'tmtMail',
            key: 'tmtMail',
            width: 150,
            ellipsis: { showTitle: true }
        },
        {
            title: () => <span>{t('reviewMeeting') + (i18n.language !== 'zh' ? ' ' : '') + t('date')}</span>,
            dataIndex: 'modifyTime',
            key: 'modifyTime',
            width: 120,
            ellipsis: { showTitle: true },
            render(value: number | null) {
                return value ? moment(value).format('YYYY-MM-DD') : ''
            }
        },
        {
            title: () => <span>{t('reviewContent')}</span>,
            dataIndex: 'reviewContent',
            key: 'reviewContent',
            // width: 150,
            ellipsis: { showTitle: true },
            render(value: string) {
                return <Popover
                    placement="topLeft"
                    title=""
                    content={
                        <div style={{ maxWidth: 400, maxHeight: 300, overflowY: 'auto', wordBreak: 'break-all' }}
                            dangerouslySetInnerHTML={{
                                __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                            }}
                        ></div>
                    }
                >
                    <div style={{ maxWidth: 400 }}
                        className='table_ellipsis'
                        dangerouslySetInnerHTML={{
                            __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                        }}
                    ></div>
                </Popover>
            },
        },
        {
            title: () => <span>{t('isCrossResult')}</span>,
            dataIndex: 'isCross',
            key: 'isCross',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: boolean | null) {
                if (value !== null) {
                    if (value) {
                        return <span>{t('Yes')}</span>
                    } else {
                        return <span>{t('No')}</span>
                    }
                } else {
                    return <></>
                }
            }
        },
        {
            title: () => <span>{t('scopeDetail')}</span>,
            dataIndex: 'need',
            key: 'need',
            ellipsis: { showTitle: true },
            render(_: string, record: any) {
                if (record.judgesType === 1) {
                    return <>
                        <span className='star_label'>{t('need')}: </span>
                        {Array(10).fill(1).map((_, index) => {
                            if (index < record.need) {
                                return (<StarFilled style={{ fontSize: 18, color: '#efdd09', marginLeft: 5 }}
                                    className='star'
                                    key={index}
                                />)
                            } else {
                                return (<StarOutlined style={{ fontSize: 18, marginLeft: 5 }}
                                    className='star'
                                    key={index}
                                />)
                            }
                        })}<br />
                        <span className='star_label'>{t('maturityStar')}: </span>
                        {Array(10).fill(1).map((_, index) => {
                            if (index < record.maturity) {
                                return (<StarFilled style={{ fontSize: 18, color: '#efdd09', marginLeft: 5 }}
                                    className='star'
                                    key={index}
                                />)
                            } else {
                                return (<StarOutlined style={{ fontSize: 18, marginLeft: 5 }}
                                    className='star'
                                    key={index}
                                />)
                            }
                        })}<br />
                        <span className='star_label'>{t('diffrentiation')}: </span>
                        {Array(10).fill(1).map((_, index) => {
                            if (index < record.diffrentiation) {
                                return (<StarFilled style={{ fontSize: 18, color: '#efdd09', marginLeft: 5 }}
                                    className='star'
                                    key={index}
                                />)
                            } else {
                                return (<StarOutlined style={{ fontSize: 18, marginLeft: 5 }}
                                    className='star'
                                    key={index}
                                />)
                            }
                        })}<br />
                        <span className='star_label'>{t('costSaving')}: </span>
                        {Array(10).fill(1).map((_, index) => {
                            if (index < record.costSaving) {
                                return (<StarFilled style={{ fontSize: 18, color: '#efdd09', marginLeft: 5 }}
                                    className='star'
                                    key={index}
                                />)
                            } else {
                                return (<StarOutlined style={{ fontSize: 18, marginLeft: 5 }}
                                    className='star'
                                    key={index}
                                />)
                            }
                        })}
                    </>
                } else {
                    return <></>
                }
            }
        }
    ]
    // 查看提案申请信息
    const getViewDetail = async (id: string) => {
        try {
            const res = await getOnlineReviewById(+id)
            console.log('------getViewDetail------', res)
            setLoaded(true)
            setFormObj({
                id: res.id,
                version: res.version,
                fileIds: res.files.map(item => item.id),
                workGroupId: res.workGroup.id,
                crossBreedWorkGroupName: res.crossBreedWorkGroup?.workGroupName ?? '',
                roadMap: res.roadMap,
                proposalName: res.proposalName,
                subsidiary: res.subsidiary,
                tmtReviewDueDate: moment(res.tmtReviewDueDate).format('YYYY-MM-DD'),
                dueDate: moment(res.dueDate).format('YYYY-MM-DD'),
                openReview: res.openReview,
                isDisruptive: res.isDisruptive,
                isCross: res.isCross,
                techLevel: res.techLevel,
                description: res.description,
                reviewType: res.reviewType,
                reviewResult: res.reviewResult,
                disruptiveReview: res.disruptiveReview,
                isCrossReview: res.isCrossReview,
                creator: res.creator || '',
                costBuss: res.costBuss ? res.costBuss.map((item: any) => item.bu) : [],
                dutyBuss: res.dutyBuss ? res.dutyBuss.map((item: any) => item.bu) : [],
                techProjects: res.techProjects,
                parentTech: res.parentTech,
                productFunction: res.productFunction,
                technologyContribution: res.technologyContribution,
                technologyLeadership: res.technologyLeadership,
                coreTechnology: res.coreTechnology,
                techScope: res.techScope,
                techPerformance: res.techPerformance,
                techSource: isNaN(Number(res.techSource)) ? res.techSource :
                    [t('independentIP'), t('outsourcedTechnology'), t('coDevelopedTechnology')][
                        Number(res.techSource) - 1
                    ],
                firstUseDate: res.firstUseDate,
                projectList: res.projectList
            })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    // 获取反馈结果报告
    const getLs = async (id: string) => {
        try {
            const res = await getOnlineReviewResult(+id)
            setFormData(res)
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
            setFormData(null)
        }
    }
    const getFeedbackLs = async (id: string) => {
        try {
            const res = await relevantGetById(+id)
            setFeedbackList(res || [])
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    
    const getFeedbackTMTLs = async (id: string) => {
        try {
            const res = await getOnlineReviewTMT(+id)
           
            if(formObj?.reviewType === 4){
                const shouldIncludeItem = (item: any) => item.reviewContent !== null || 
                       item.isPL || 
                       (item?.workGroup?.id === formObj?.workGroupId)
                // 使用过滤函数进行过滤
                const filteredData = res.filter(shouldIncludeItem)
                // 直接赋值，避免多余的逻辑，因为 filter 结果本身就是数组
                setFeedbackTMTList(filteredData)
            }
            setFeedbackTMTList(res)
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    const [routes, setRoutes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/techReviewProgress',
            breadcrumbName: t('technicalReviewProcess'),
        },
        {
            path: '/',
            breadcrumbName: t('viewFeedback'),
        },
    ])
    useEffect(() => {
        const routeParams = new URLSearchParams(location.search)
        const progressIdParam = routeParams.get('progressId')
        const progressNameParam = routeParams.get('name')
        const type = routeParams.get('type')
        if (type) {
            localStorage.setItem('curTab', type)
        }
        if (progressIdParam) {
            getViewDetail(progressIdParam)
        }
        routes[1] = {
            path: '/techReviewProgress',
            breadcrumbName: approvalType[(Number(type) || 1) - 1].label
        }
        setRoutes([...routes])
        setProgressName(progressNameParam || '')
    }, [])

    useEffect(() => {
        const routeParams = new URLSearchParams(location.search)
        const progressIdParam = routeParams.get('progressId')
        if (progressIdParam) {
            getLs(progressIdParam)
            getFeedbackLs(progressIdParam)
            getFeedbackTMTLs(progressIdParam)
        }
    }, [formObj])
    return (
        <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                route={route}
                dispatch={dispatch}
            />
            <Space direction="vertical" size={0} style={{ display: 'flex' }}>
                <PageHeader className='chart_title'
                    onBack={() => null}
                    title={progressName}
                />
                <Card title={t('viewInfo')} className="edit_table"
                    style={{ paddingTop: 0 }}
                >
                    {loaded ?
                        <Form {...layout} ref={formRef} className="ti_an_detail">
                            <Row>
                                <Col span={12}>
                                    <Form.Item name='workGroupId'
                                        label={<span className='label'>{t('Work Group')}</span>}
                                    >
                                        {workgroupList.find(workgroup => workgroup.id === formObj?.workGroupId)?.groupName}
                                    </Form.Item>
                                </Col>
                                {formObj?.reviewType !== 4 ? <Col span={12}>
                                    <Form.Item name='tmtReviewDueDate'
                                        label={<span className='label'>{t('feedDueDate')}</span>}
                                    >
                                        {formObj?.tmtReviewDueDate}
                                    </Form.Item>
                                </Col> : <Col span={12}>
                                    <Form.Item name='costBuss'
                                        label={<span className='label'>{t('proposalAttributionBusinessModule')}</span>}
                                    >
                                        <div style={{ wordWrap: 'break-word' }}>{formObj?.costBuss?.join(', ')}</div>
                                    </Form.Item>
                                </Col>}
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <Form.Item name='proposalName'
                                        label={<span className='label'>{t('proposalName')}</span>}
                                    >
                                        {formObj?.proposalName}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name='dueDate'
                                        label={<span className='label'>{formObj?.reviewType === 4 ? joinTranslatedStrings(t('PL TMT'), t('feedEndDate')) : t('feedEndDate')}</span>}
                                    >
                                        {formObj?.dueDate}
                                    </Form.Item>
                                </Col>
                            </Row>
                            {formObj?.reviewType !== 3 && formObj?.reviewType !== 4 && (<Row>
                                <Col span={12}>
                                    <Form.Item name='costBuss'
                                        label={<span className='label'>{t('developCostAttribute')}</span>}
                                    >
                                        <div style={{ wordWrap: 'break-word' }}>{formObj?.costBuss?.join(', ')}</div>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name='dutyBuss'
                                        label={<span className='label'>{t('developDutySubject')}</span>}
                                    >
                                        <div style={{ wordWrap: 'break-word' }}>{formObj?.dutyBuss?.join(', ')}</div>
                                    </Form.Item>
                                </Col>
                            </Row>)}
                            {formObj?.reviewType === 4 && <Row>
                                <Col span={12}>
                                    <Form.Item name='parentTech'
                                        label={<span className='label'>{t('higherLevelTechnicalPoints')}</span>}
                                    >
                                        {formObj?.parentTech}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name='productFunction'
                                        label={<span className='label'>{t('productFeatures')}</span>}
                                    >
                                        {formObj?.productFunction}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name='techScope'
                                        label={<span className='label'>{t('technicalApplicationRange')}</span>}
                                    >
                                        {formObj?.techScope}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name='techPerformance'
                                        label={<span className='label'>{t('technicalPerformanceIndicators')}</span>}
                                    >
                                        {formObj?.techPerformance}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name='techSource'
                                        label={<span className='label'>{t('technicalOrigin')}</span>}
                                    >
                                        {formObj?.techSource}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name='firstUseDate'
                                        label={<span className='label'>{t('estimatedFirstApplicationTime')}</span>}
                                    >
                                        {formObj?.firstUseDate}
                                    </Form.Item>
                                </Col>
                            </Row>}
                            <>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item name='isDisruptive'
                                            label={<span className='label'>{t('isApply') + (i18n.language !== 'zh' ? ' ' : '') + t('isDisruptive')}</span>}
                                        >
                                            {formObj?.isDisruptive ? t('Yes') : t('No')}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name='disruptiveReview'
                                            label={<span className='label'>{t('isDisruptiveResult') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResult')}</span>}
                                        >
                                            {(formObj?.reviewResult == null || !formObj?.isDisruptive) ? 'NA' : (formObj?.disruptiveReview !== null ? ((formObj?.disruptiveReview >= 6) ? t('Yes') : t('No')) : 'NA')}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item name='isCross'
                                            label={<span className='label'>{t('isApply') + (i18n.language !== 'zh' ? ' ' : '') + t('isCross')}</span>}
                                        >
                                            {formObj?.isCross ? t('Yes') : t('No')}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name='isCrossReview'
                                            label={<span className='label'>{t('isCrossResult') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResult')}</span>}
                                        >
                                            {(formObj?.reviewResult == null || !formObj?.isCross) ? 'NA' : (formObj?.isCrossReview !== null ? (formObj?.isCrossReview ? t('Yes') : t('No')) : 'NA')}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                {formObj?.isCross && <Row>
                                    <Col span={12}>
                                        <Form.Item name='isCross'
                                            label={<span className='label'>{'Crossbreed' + (i18n.language !== 'zh' ? ' ' : '') + t('Work Group')}</span>}
                                        >
                                            {formObj?.crossBreedWorkGroupName}
                                        </Form.Item>
                                    </Col>
                                </Row>}
                            </>
                            <Row>
                                <Col span={12}>
                                    <Form.Item name='description'
                                        label={<span className='label'>{(formObj?.reviewType ? approvalType[formObj.reviewType - 1].label : '')
                                            + (i18n.language !== 'zh' ? ' ' : '') + t('description')}</span>}
                                    >
                                        <div dangerouslySetInnerHTML={{
                                            __html: formObj?.description ? JSON.parse(formObj?.description).str : ''
                                        }} style={{ wordBreak: 'break-word' }}></div>
                                    </Form.Item>
                                </Col>
                            </Row>
                            {(formObj?.reviewType === 2 || formObj?.reviewType === 3) && <>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item
                                            label={<span className='label'>{t('tech') + (i18n.language !== 'zh' ? ' ' : '') + t('list')}</span>}
                                        >{formObj?.techProjects && formObj.techProjects.length > 0 ? '' : '无'}</Form.Item>
                                    </Col>
                                </Row>
                                {formObj && formObj?.techProjects.map((techObj: any) => <Space direction="vertical" size={0} key={techObj.id}
                                    className='form_item_mb'
                                    style={{ width: '100%' }}
                                >
                                    <Row>
                                        <Col span={12}>
                                            {/* 技术点信息 */}
                                            <Form.Item label={<span className='label'>{t('tech') + (i18n.language !== 'zh' ? ' ' : '') + t('name')}</span>}>
                                                <div style={{ display: 'flex' }}>
                                                    <div className='desc' dangerouslySetInnerHTML={{
                                                        __html: (techObj && techObj?.techName && techObj.techName.includes('str') && techObj.techName.includes('obj'))
                                                            ? JSON.parse(techObj.techName).str : techObj.techName
                                                    }}></div>
                                                </div>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label={<span className='label'>{t('subsidiary')}</span>}>
                                                {techObj && <>
                                                    <Text>{techObj.subsidiary}</Text>
                                                </>}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label={<span className='label'>{t('PTN')}</span>}>
                                                {techObj && <>
                                                    <Text>{techObj.techPtn}</Text>
                                                </>}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label={<span className='label'>{t('description')}</span>}
                                            >
                                                <div className='desc desc_break' dangerouslySetInnerHTML={{
                                                    __html: (techObj && techObj?.description && techObj.description.includes('str') && techObj.description.includes('obj'))
                                                        ? JSON.parse(techObj.description).str : techObj.description
                                                }}></div>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label={<span className='label'>{t('techLevel')}</span>}
                                            >
                                                <span>{
                                                    [t('core'), t('key'), t('general'), t('normal')][(techObj?.techLevel as number || 1) - 1]
                                                }</span>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={12}>
                                            <Form.Item label={<span className="label">{t('relatedTechProjects')}</span>}>
                                                {formObj?.projectList?.length > 0 ? (
                                                    (() => {
                                                        // Find the latest date among projects with a valid creation_date
                                                        const latestDate = formObj.projectList.reduce((latest: string | null, proj: any) => {
                                                            if (!proj.creation_date) return latest // Skip if no creation_date
                                                            return new Date(proj.creation_date) > new Date(latest ?? proj.creation_date)
                                                                ? proj.creation_date
                                                                : latest
                                                        }, null)

                                                        // Separate projects with the latest date and those without a creation_date
                                                        const latestProjects = formObj.projectList.filter(
                                                            (proj: any) => proj.creation_date === latestDate || !proj.creation_date
                                                        )

                                                        // If no valid projects, show fallback message
                                                        if (latestProjects.length === 0) {
                                                            return <span>No Related Technical Projects</span>
                                                        }

                                                        // Map through the filtered projects
                                                        return latestProjects.map((proj: any, index: number) => (
                                                            <React.Fragment key={index}>
                                                                <Text>{proj.projectName || 'Unnamed Project'}</Text>
                                                                {index < latestProjects.length - 1 && <Text>, </Text>} {/* Add comma if not the last item */}
                                                            </React.Fragment>
                                                        ))
                                                    })()
                                                ) : (
                                                    <span>No Related Technical Projects</span>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                </Space>)}
                            </>}
                        </Form>
                        : (
                            <div
                                style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                            ><Spin size="large" /></div>
                        )
                    }
                </Card>
                <Tabs className="edit_table"
                    style={{ marginTop: 15, marginBottom: 15 }}
                    defaultActiveKey="1"
                    type="card"
                >
                    {formObj?.reviewType !== 4 && <TabPane tab={t('viewFeedback')} key="1">
                        {formData === undefined ? (
                            <div
                                style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                            ><Spin size="large" /></div>
                        ) : (formData ? (
                            <Form {...layout}
                                className="edit_table ti_an_detail"
                                style={{ paddingTop: 0 }}
                            >
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('allNum')}</span>}>
                                            {formData.all}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('disPassed')}</span>}>
                                            {formData.disPassed}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('disPassedUsers')}</span>}>
                                            {formData.disPassedUsers.length > 0 ? formData.disPassedUsers.join(', ') : 'NA'}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('reviewer passed')}</span>}>
                                            {formData.passed}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('passedUser')}</span>}>
                                            {formData.passedUser.length > 0 ? formData.passedUser.join(', ') : 'NA'}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('onParticipate')}</span>}>
                                            {formData.onParticipate}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('sitInOnPersonList')}</span>}>
                                            {formData.auditUser.length > 0 ? formData.auditUser.join(', ') : 'NA'}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('joinPersonList')}</span>}>
                                            {formData.onParticipateUsers.length > 0 ? formData.onParticipateUsers.join(', ') : 'NA'}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('noParticipate')}</span>}>
                                            {formData.noParticipate}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('noParticipateUsers')}</span>}>
                                            {formData.noParticipateUsers.length > 0 ? formData.noParticipateUsers.join(', ') : 'NA'}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('abstentionNum')}</span>}>
                                            {formData.abstention}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('abstentionUsers')}</span>}>
                                            {formData.abstentionUsers.length > 0 ? formData.abstentionUsers.join(', ') : 'NA'}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    {formObj?.reviewType === 1 && <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('disruptiveScore')}</span>}>
                                            {(!formObj || formData.reviewResult === null) ? 'NA' : (formObj?.isDisruptive ? formData.disruptiveScore : 'NA')}
                                        </Form.Item>
                                    </Col>}
                                    <Col span={12}>
                                        <Form.Item label={<span className='label'>{t('reviewResult')}</span>}>
                                            {formData.reviewResult === null ? t('reviewResultNull') :
                                                (formData.reviewResult ? t('reviewResultTrue') : t('reviewResultFalse'))}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        ) : <Empty />)}
                    </TabPane>}
                    {formObj?.reviewType !== 4 && <TabPane tab={joinTranslatedStrings(t('ITMT'), t('feedback'),t('list'))} key="2">
                        <Table className='index_ls' bordered
                            rowKey='id'
                            dataSource={feedbackList}
                            columns={columns}
                            pagination={false}
                        />
                    </TabPane>}
                    <TabPane tab={joinTranslatedStrings(t('ITMT'), t('userList'))} key="3">
                        <Table className='index_ls' bordered
                            scroll={{ x: 'max-content' }}
                            rowKey='id'
                            dataSource={feedbackTMTList}
                            columns={tmtColumns.filter(v => {
                                if (v.key == 'need') {
                                    return (formObj?.reviewType === 1 && formObj?.isDisruptive)
                                } else if (v.key == 'isCross') {
                                    return (formObj?.reviewType === 1 && formObj?.isCross)
                                } else if (v.key === 'workGroup' || v.key === 'isParticipate') {
                                    return formObj?.reviewType !== 4
                                } else if (v.key === 'technologyLeadership' || v.key === 'technologyContribution' || v.key === 'coreTechnology') {
                                    return formObj?.reviewType !== 1
                                } else {
                                    return true
                                }
                            })}
                            pagination={false}
                        />
                    </TabPane>
                </Tabs>
            </Space>
        </ConfigProvider>
    )
}

export default OnlineReviewTMTLs
